import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { SelectionGroup, SelectionGroupItem, Typography } from 'fronton-react';
import { WallHorizontal, WallDiagonal } from 'assets';
import { Thickness } from './const';

const thickness = [
  {
    name: Thickness.horizontal,
    label: 'Горизонтальное',
    getIcon: () => <WallHorizontal />,
  },
  {
    name: Thickness.diagonal,
    label: 'Диагональное',
    getIcon: () => <WallDiagonal />,
  },
];

export const LayerThicknessForm = () => {
  const { control, setValue } = useFormContext();
  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="l" color="text-primary" size="body_accent">
            Направление укладки
          </Typography>
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name="thickness"
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectionGroup
              active={value}
              onChange={(_, thickValue) => {
                onChange();
                setValue('thickness', thickValue);
              }}
              variant="composite"
              className={SelectionGroupClassname}>
              {thickness.map((thickItem, idx) => (
                <SelectionGroupItem key={thickness[idx].name} value={thickness[idx].name}>
                  <LayerThickness>
                    {thickness[idx].getIcon()}
                    <Typography variant="m" size="body_accent" color="text-primary">
                      {thickness[idx].label}
                    </Typography>
                  </LayerThickness>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
          )}
        />
      </LayerContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LayerThickness = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SelectionGroupClassname = css`
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 65%;
  }

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

const LayerContainer = styled.div`
  margin-top: 24px;
`;
